import { TourButton } from '@shared/components/tours'
import { Link } from 'react-router-dom'

export function Header() {
  return (
    <header className="sticky flex flex-col items-center top-0 z-50 w-full drop-shadow-md border-b border-border bg-card">
      <div className="mx-auto w-full max-w-md">
        <div className="container flex h-16 items-center justify-between px-4">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <img
              src="/logo.svg"
              alt="ProFessionals"
              className="h-8 w-auto"
              onError={(e) => {
                // Fallback if logo doesn't exist
                e.currentTarget.style.display = 'none'
              }}
            />
          </Link>

          {/* Tour Button */}
          <div className="flex items-center gap-2" data-tour="header-menu">
            <TourButton
              variant="ghost"
              size="icon"
              aria-label="Abrir menú de tours guiados"
            />
          </div>
        </div>
      </div>
    </header>
  )
}
